import { Box, CardMedia, styled, Typography } from '@mui/material';
import Image from 'next/image';
import { useMemo } from 'react';
import { PdpInfoDTO } from '@/types/models';
import { planPhaseMapper } from '@/utils/mapper/planPhase';
const Video = styled('video')({});
const PlanInfoMedia = ({
  data,
  foundraiser
}: {
  data: PdpInfoDTO;
  foundraiser: boolean;
}) => {
  const isVideo = useMemo(() => {
    return data.banner?.extension === 'mp4' || data.banner?.extension === 'mkv';
  }, [data.banner?.extension]);
  return <CardMedia sx={{
    position: 'relative'
  }} data-sentry-element="CardMedia" data-sentry-component="PlanInfoMedia" data-sentry-source-file="PlanInfoMedia.tsx">
      <Box sx={{
      bgcolor: 'background.bg',
      width: '100%',
      height: 193,
      overflow: 'hidden',
      position: 'relative',
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: '100px',
        background: 'linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.02))'
      },
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: 0,
        height: '100px',
        width: '100%',
        background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.02))'
      }
    }} data-sentry-element="Box" data-sentry-source-file="PlanInfoMedia.tsx">
        {isVideo ? <>
            <Video muted autoPlay loop controls={false} playsInline webkit-playsinline='true' sx={{
          pointerEvents: 'none',
          width: '100%'
        }}>
              <source src={data?.banner?.url ?? ''} type='video/mp4'></source>
              Your browser does not support the video tag.
            </Video>
            <Box position='absolute' left={0} top={0} right={0} bottom={0} zIndex={1} />
          </> : <Image src={data?.banner?.url.toString() ?? ''} height={193} width={379} sizes='100vw' style={{
        width: '100%',
        height: 'auto'
      }} alt={data.title || ''} />}
      </Box>
      {foundraiser && <Typography sx={{
      position: 'absolute',
      bottom: 0,
      p: 'var(--spacing_m)'
    }} variant='bodyLargeStrong__Wallfund' color='onNegative.text'>
          {data.title}
        </Typography>}

      {(data.status === 'funded' || data.status === 'expired') && <Box sx={{
      position: 'absolute',
      top: 'var(--spacing_m)',
      right: 'var(--spacing_m)',
      overflow: 'hidden',
      display: 'flex',
      minWidth: 126,
      height: 48
    }}>
          <Image src={`/icons/plans/${data.status === 'funded' ? 'funded-plan' : 'expired-plan'}.png`} height={126} width={48} sizes='100vw' style={{
        width: '100%',
        height: 'auto',
        margin: '0 auto',
        maxWidth: 150
      }} alt={planPhaseMapper[data.status] || ''} />
        </Box>}
    </CardMedia>;
};
export default PlanInfoMedia;